export const elementTypes = {
  DEFAULT: 'default',
  TEXT: 'text',
  IMAGE: 'image',
  BUTTON: 'button',
  SQUARE: 'square',
  RHOMBUS: 'rhombus',
  CIRCLE: 'circle',
  LINE: 'line',
  TRIANGLE: 'triangle',
  IFRAME: 'iframe',
  VIDEO: 'video',
  ARROW: 'arrow',
  STAR: 'star'
}


// WEBPACK FOOTER //
// ./src/components/commons/editor/configs/ElementTypes.js